module.exports = __webpack_public_path__ + "components/MapControl/svg/Synagoga.svg?f61bebbd";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Synagoga.svg
// module id = 2109
// module chunks = 0